export default "__VITE_ASSET__a1005495__"